module.exports = __webpack_public_path__ + "img/dia.b973da03.png";